<template>
  <div class="join-class-box main-box">
    <div class="page msg_success js_show">
      <div class="weui-msg" v-show="false">
        <div class="weui-msg__icon-area">
          <div class="code-box">
            <div id="qrcode">
              <img ref="refQRCode" />
            </div>
          </div>
        </div>
        <div class="weui-msg__text-area">
          <h2 class="weui-msg__title">长按二维码加入班级</h2>
          <p class="weui-msg__desc" v-show="touched">未能识别二维码，点击下方按钮加入班级</a></p>
        </div>
        <div class="weui-msg__opr-area" v-show="touched">
          <p class="weui-btn-area">
            <a href="javascript:void(0);" @click="join" class="weui-btn weui-btn_primary">加入班级</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcode'
export default {
  data () {
    return {
      init: false,
      success: false,
      commiting: true,
      userId: null,
      flag: false,
      coursewareId: null,
      touched: false,
      msg: '正在提交...'
    }
  },
  filters: {

  },
  methods: {
    join: function () {
      var _this = this;
      if (_this.joining) {
        return;
      }
      _this.joining = true;
      _this.loading = weui.loading('正在提交');
      _this.$axios.post(_this.stuApiUrl + "/sign/join-class", _this.$qs.stringify({
        schoolId: _this.schoolId,
        classId: _this.classId
      })).then(function (response) {
        _this.joining = false;
        _this.loading.hide();
        _this.opacity = 1;
        _this.success = response.data.success;

        if (!response.data.success) {
          _this.msg = response.data.info;
          return weui.alert(response.data.info);
        }

        var clazz = response.data.class;
        var url = '/student/course/list';
        if (clazz) {
          url = '/student/course/course-detail/' + clazz.courseId + '/' + _this.classId;
        }

        weui.toast(response.data.info, {
          duration: 2000,
          callback: function () {
			console.log("zmf class " + url)
            _this.$router.replace(url);
          }
        });

      }).catch(function (error) {
        _this.loading.hide();
        _this.msg = '签到失败';
        _this.joining = false;
      });
    },
    loadData: function () {
      var _this = this;
      _this.loading = weui.loading('正在加载');
      _this.$axios.post(_this.stuApiUrl + "/scan/class/code", _this.$qs.stringify({
        schoolId: _this.schoolId,
        classId: _this.classId
      })).then(function (response) {
        _this.loading.hide();
        if (!response.data.success) {
          return weui.alert(response.data.info)
        }
        var url = response.data.url;

        let options = {
          margin: 0,
          version: 4
        }
        QRCode.toDataURL(url, options)
          .then(url => {
            console.log(url)
            _this.$refs.refQRCode.src = url
          })
          .catch(err => {
            console.error(err)
          })
        _this.init = true
        _this.join()
      }).catch(function (error) {
        _this.loading.hide()
      })
    },
    initEvent: function () {
      var _this = this;
      $('.join-class-box').on('touchend', function () {
        _this.touched = true;
      });
    }
  },
  mounted () {
    var _this = this;
    _this.schoolId = this.$route.params.schoolId;
    _this.classId = this.$route.params.classId;
    _this.initEvent();
    _this.loadData();

  },
  beforeDestroy () {
  },
  destroyed () {
  }
}
</script>
<style scoped>
.main-box {
  position: relative;
  height: 100%;
  box-sizing: border-box;
}
.code-box {
  width: 5rem;
  height: 5rem;
  margin: auto;
  margin-top: 0.8rem;
}

#qrcode,
.code-box img {
  width: 100%;
  height: 100%;
}

/* .weui-msg__text-area{
    position: absolute;
    width: 100%;
    top: 1rem;
    text-align: center;
} */
</style>



// WEBPACK FOOTER //
// src/components/student/user/join-class.vue